import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetGuideCommentsQueryVariables = Types.Exact<{
  guideId: Types.Scalars['uuid']['input'];
  isAnon?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetGuideCommentsQuery = { __typename?: 'query_root', guide_comments: Array<{ __typename?: 'guide_comments', id?: any, step_number: number, comment?: string, created_at?: any, guide_id?: any, user?: { __typename?: 'users', first_name: string, last_name: string, profile_photo?: string | null } }> };


export const GetGuideCommentsDocument = gql`
    query getGuideComments($guideId: uuid!, $isAnon: Boolean = false) {
  guide_comments(
    where: {guide_id: {_eq: $guideId}}
    order_by: {step_number: asc, created_at: asc}
  ) {
    id @skip(if: $isAnon)
    step_number
    comment @skip(if: $isAnon)
    created_at @skip(if: $isAnon)
    guide_id @skip(if: $isAnon)
    user @skip(if: $isAnon) {
      first_name
      last_name
      profile_photo
    }
  }
}
    `;

/**
 * __useGetGuideCommentsQuery__
 *
 * To run a query within a React component, call `useGetGuideCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuideCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuideCommentsQuery({
 *   variables: {
 *      guideId: // value for 'guideId'
 *      isAnon: // value for 'isAnon'
 *   },
 * });
 */
export function useGetGuideCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetGuideCommentsQuery, GetGuideCommentsQueryVariables> & ({ variables: GetGuideCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuideCommentsQuery, GetGuideCommentsQueryVariables>(GetGuideCommentsDocument, options);
      }
export function useGetGuideCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuideCommentsQuery, GetGuideCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuideCommentsQuery, GetGuideCommentsQueryVariables>(GetGuideCommentsDocument, options);
        }
export function useGetGuideCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuideCommentsQuery, GetGuideCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGuideCommentsQuery, GetGuideCommentsQueryVariables>(GetGuideCommentsDocument, options);
        }
export type GetGuideCommentsQueryHookResult = ReturnType<typeof useGetGuideCommentsQuery>;
export type GetGuideCommentsLazyQueryHookResult = ReturnType<typeof useGetGuideCommentsLazyQuery>;
export type GetGuideCommentsSuspenseQueryHookResult = ReturnType<typeof useGetGuideCommentsSuspenseQuery>;
export type GetGuideCommentsQueryResult = Apollo.QueryResult<GetGuideCommentsQuery, GetGuideCommentsQueryVariables>;